import {
  Typography,
  Box,
} from "@mui/material";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { AccessTime, PersonOutline, PersonOff } from "@mui/icons-material";
import localize from "../../../common/localize";

export default function VehicleMovementItem({ assignment, isLast }) {
  const isAssigned = !!assignment.AssignedTo;
  const bgColor = isAssigned ? "#00B4CB" : "#F29396";
  const fgColor = isAssigned ? "#004D57" : "#7A0000";
  const changeDate = new Date(assignment.CreationDate);

  const dateStr = changeDate.toLocaleString(undefined, {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot
          sx={{
            bgcolor: bgColor,
            boxShadow: `0 0 0 3px ${bgColor}33`,
            width: 14,
            height: 14,
            m: "12px 0",
          }}
        />
        {!isLast && <TimelineConnector sx={{ bgcolor: "divider" }} />}
      </TimelineSeparator>

      <TimelineContent sx={{ pb: 3, pt: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
          <AccessTime sx={{ fontSize: 14, color: "text.disabled" }} />
          <Typography variant="caption" color="text.secondary">
            {dateStr}
          </Typography>
        </Box>

        <Box
          sx={{
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            overflow: "hidden",
            transition: "box-shadow 0.2s ease",
            "&:hover": {
              boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            },
          }}
        >
          <Box sx={{ px: 2, py: 1.5 }}>
            {isAssigned ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PersonOutline sx={{ fontSize: 20, color: fgColor }} />
                <Box>
                  <Typography variant="body2" fontWeight={600}>
                    {`${assignment.AssignedTo.SurName} ${assignment.AssignedTo.LastName}`}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {`${localize.identification}: ${assignment.AssignedTo?.Identification}`}
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PersonOff sx={{ fontSize: 20, color: fgColor }} />
                <Typography variant="body2" fontWeight={600} sx={{ color: fgColor }}>
                  {localize.unassigned}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </TimelineContent>
    </TimelineItem>
  );
}
